<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 
    import License from '../../components/License.svelte'; 
    import Token from '../../components/Token.svelte'; 
    

    let isLoading = false;


    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            <Token />
            <div class="container content-container konimbo m-0 p-0">
                <h1 class="text-3xl font-bold mb-4">{$_('docs.konimbo.title')}</h1>
              
                <h2 id="konimbo-installation" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.konimbo.installation.title')}</h2>
                <p class="text-base mb-4">{$_('docs.konimbo.installation.intro')}</p>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.konimbo.installation.install')}</h3>
                <ol class="list-decimal list-inside mb-4">
                  <li>{$_('docs.konimbo.installation.install_step_1')}</li>
                  <li>{$_('docs.konimbo.installation.install_step_2')}</li>
                  <li>{$_('docs.konimbo.installation.install_step_3')}</li>
                </ol>
              
                <h2 id="konimbo-configure" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.konimbo.configure.title')}</h2>
                <p class="text-base mb-4">{$_('docs.konimbo.configure.intro_1')}</p>
                <p class="text-base mb-4">{$_('docs.konimbo.configure.intro_2')}</p>
                <ol class="list-decimal list-inside mb-4">
                  <li>{$_('docs.konimbo.configure.step_1')}</li>
                  <li>{$_('docs.konimbo.configure.step_2')}</li>
                  <li>{$_('docs.konimbo.configure.step_3')}</li>
                  <li>{$_('docs.konimbo.configure.step_4')}</li>
                  <li>
                    {$_('docs.konimbo.configure.step_5_intro')}
                    <pre class="bg-gray-100 p-2 rounded mt-2 ltr text-left w-full"><code>
                      &lt;script type="text/javascript"&gt;
                      var datalogics_customer_number = 'var.customer_number';
                      // var datalogics_customer_number_pickup = 'var.customer_number_pickup';
                      var datalogics_token = 'var.token';
                      var datalogics_label = 'var.label';
                      var datalogics_city = 'var.city';
                      var datalogics_street = 'var.street';
                      var datalogics_house = 'var.house';
                      var datalogics_phone = 'var.phone';
                      &lt;/script&gt;
                      &lt;script type="text/javascript" src="https://connect.datalogics.co.il/shipping/konimboAdmin.js"&gt;&lt;/script&gt;
                    </code></pre>
                  </li>
                  <li>
                    {$_('docs.konimbo.configure.step_6_intro')}
                    <pre class="bg-gray-100 p-2 rounded mt-2 ltr text-left w-full"><code>
                      &lt;vars&gt;
                      &lt;var&gt;&lt;label&gt;מספר חוזה&lt;/label&gt;&lt;name&gt;customer_number&lt;/name&gt;&lt;value/&gt;&lt;tab&gt;משתנים&lt;/tab&gt;&lt;group/&gt;&lt;tip/&gt;&lt;type&gt;text&lt;/type&gt;&lt;/var&gt;
                      &lt;var&gt;&lt;label&gt;טוקן&lt;/label&gt;&lt;name&gt;token&lt;/name&gt;&lt;value/&gt;&lt;tab&gt;משתנים&lt;/tab&gt;&lt;group/&gt;&lt;tip/&gt;&lt;type&gt;text&lt;/type&gt;&lt;/var&gt;
                      &lt;var&gt;&lt;label&gt;שם החברה על התווית&lt;/label&gt;&lt;name&gt;label&lt;/name&gt;&lt;value/&gt;&lt;tab&gt;משתנים&lt;/tab&gt;&lt;group/&gt;&lt;tip/&gt;&lt;type&gt;text&lt;/type&gt;&lt;/var&gt;
                      &lt;var&gt;&lt;label&gt;עיר איסוף החבילה&lt;/label&gt;&lt;name&gt;city&lt;/name&gt;&lt;value/&gt;&lt;tab&gt;משתנים&lt;/tab&gt;&lt;group/&gt;&lt;tip/&gt;&lt;type&gt;text&lt;/type&gt;&lt;/var&gt;
                      &lt;var&gt;&lt;label&gt;רחוב איסוף החבילה&lt;/label&gt;&lt;name&gt;street&lt;/name&gt;&lt;value/&gt;&lt;tab&gt;משתנים&lt;/tab&gt;&lt;group/&gt;&lt;tip/&gt;&lt;type&gt;text&lt;/type&gt;&lt;/var&gt;
                      &lt;var&gt;&lt;label&gt;מספר בית לאיסוף החבילה&lt;/label&gt;&lt;name&gt;house&lt;/name&gt;&lt;value/&gt;&lt;tab&gt;משתנים&lt;/tab&gt;&lt;group/&gt;&lt;tip/&gt;&lt;type&gt;text&lt;/type&gt;&lt;/var&gt;
                      &lt;var&gt;&lt;label&gt;טלפון בית העסק&lt;/label&gt;&lt;name&gt;phone&lt;/name&gt;&lt;value/&gt;&lt;tab&gt;משתנים&lt;/tab&gt;&lt;group/&gt;&lt;tip/&gt;&lt;type&gt;text&lt;/type&gt;&lt;/var&gt;
                      &lt;/vars&gt;
                    </code></pre>
                  </li>
                </ol>
                <p class="text-base mb-4">{$_('docs.konimbo.configure.save')}</p>
              
                <h2 id="konimbo-usage" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.konimbo.usage.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.konimbo.usage.widgets')}</h3>
                <p class="text-base mb-4">{$_('docs.konimbo.usage.widgets_intro_1')}</p>
                <p class="text-base mb-4">{$_('docs.konimbo.usage.widgets_intro_2')}</p>
                <p class="text-base mb-4">{$_('docs.konimbo.usage.widgets_intro_3')}</p>
              
                <h2 id="konimbo-troubleshooting" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.konimbo.troubleshooting.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.konimbo.troubleshooting.common_issues')}</h3>
                <ol class="list-decimal list-inside mb-4">
                  <li><strong>{$_('docs.konimbo.troubleshooting.issue_1_title')}</strong> {$_('docs.konimbo.troubleshooting.issue_1')}</li>
                </ol>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.konimbo.troubleshooting.faq')}</h3>
                <ol class="list-decimal list-inside mb-4">
                  <li>
                    <div><strong>{$_('docs.konimbo.troubleshooting.faq_1_q')}</strong></div>
                    <div>{$_('docs.konimbo.troubleshooting.faq_1_a')}</div>
                  </li>
                  <li>
                    <div><strong>{$_('docs.konimbo.troubleshooting.faq_2_q')}</strong></div>
                    <div>{$_('docs.konimbo.troubleshooting.faq_2_a')}</div>
                  </li>
                </ol>
              
                <h2 id="konimbo-support" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.konimbo.support.title')}</h2>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.konimbo.support.getting_help')}</h3>
                <p class="text-base mb-4">{$_('docs.konimbo.support.getting_help_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                  <li><strong>{$_('docs.konimbo.support.help_step_1_title')}</strong> {$_('docs.konimbo.support.help_step_1')}</li>
                  <li><strong>{$_('docs.konimbo.support.help_step_2_title')}</strong> {$_('docs.konimbo.support.help_step_2')}</li>
                </ol>
              
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.konimbo.support.reporting')}</h3>
                <p class="text-base mb-4">{$_('docs.konimbo.support.reporting_intro')}</p>
                <ol class="list-decimal list-inside mb-4">
                  <li><strong>{$_('docs.konimbo.support.report_step_1_title')}</strong> {$_('docs.konimbo.support.report_step_1')}</li>
                  <li><strong>{$_('docs.konimbo.support.report_step_2_title')}</strong> {$_('docs.konimbo.support.report_step_2')}</li>
                </ol>
              
                <h2 id="konimbo-changelog" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.konimbo.changelog.title')}</h2>
                <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.konimbo.changelog.version')}</h3>
                <ul class="list-disc list-inside mb-4">
                  <li><strong>{$_('docs.konimbo.changelog.added_title')}</strong> {$_('docs.konimbo.changelog.added')}</li>
                  <li><strong>{$_('docs.konimbo.changelog.updated_title')}</strong> {$_('docs.konimbo.changelog.updated')}</li>
                  <li><strong>{$_('docs.konimbo.changelog.fixed_title')}</strong> {$_('docs.konimbo.changelog.fixed')}</li>
                  <li><strong>{$_('docs.konimbo.changelog.removed_title')}</strong> {$_('docs.konimbo.changelog.removed')}</li>
                </ul>
              
                <h2 id="konimbo-license" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.konimbo.license.title')}</h2>
                <License />
            </div>

        </div>
    </div>
</div>